var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.454 11.645c.56 0 .984-.424.984-.997a.979.979 0 0 0-.286-.71l-2.723-2.702c.76-.162 1.619-.237 2.577-.237C21 7 24.996 11 24.996 15.997c0 5.01-3.997 9.023-8.99 9.023s-9.002-4.013-9.002-9.023c0-.598-.373-1.034-.97-1.034-.61 0-1.034.436-1.034 1.034a10.986 10.986 0 0 0 11.006 11.03c6.1 0 10.994-4.911 10.994-11.03A10.962 10.962 0 0 0 16.006 4.993c-.735 0-1.456.075-2.166.2l2.324-2.266c.187-.199.274-.449.274-.71 0-.573-.423-1.022-.971-1.022-.311 0-.56.1-.735.3l-4.13 4.208c-.199.2-.31.474-.31.748 0 .287.099.536.31.748l4.13 4.16a.976.976 0 0 0 .722.286z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/Rotate_Left.a23647cc624fda075e3cd7216ad35921.svg";
export { ForwardRef as ReactComponent };